import { React, useState } from "react";
import { Link, useLocation } from "react-router-dom";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons"

import LOGO from "../../images/logo.svg";

import { Wrapper, Content, Logo, NavList, Hamburger, SideNav, CloseMenuBTN } from "./Nav.styles";

const Nav = () => {
  const location = useLocation();

  const links = [
    ["Home", "/"],
    ["About", "/about"],
    ["Projects", "/projects"],
    ["Blog", "/blog"],
    ["Contact", "/contact"],
  ];


  const [isOpenMenu, SetIsOpenMenu] = useState(false);
  const OpenMenu = () => {
    SetIsOpenMenu(!isOpenMenu);
  };
  const CloseMenu = () => {
    SetIsOpenMenu(false);
  };

  return (
    <Wrapper>
      <Content>
        <Link to='/'>
          {/* <svg width="255" height="27" viewBox="0 0 255 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.3809 26H16.1074V15.0312H5.82422V26H0.550781V0.40625H5.82422V10.7773H16.1074V0.40625H21.3809V26ZM40.7695 20.7266H31.5234L29.7656 26H24.1582L33.6855 0.40625H38.5723L48.1523 26H42.5449L40.7695 20.7266ZM32.9473 16.4551H39.3457L36.1289 6.875L32.9473 16.4551ZM57.4336 0.40625L64.0078 18.9688L70.5469 0.40625H77.4727V26H72.1816V19.0039L72.709 6.92773L65.8008 26H62.1797L55.2891 6.94531L55.8164 19.0039V26H50.543V0.40625H57.4336ZM96.8438 20.7266H87.5977L85.8398 26H80.2324L89.7598 0.40625H94.6465L104.227 26H98.6191L96.8438 20.7266ZM89.0215 16.4551H95.4199L92.2031 6.875L89.0215 16.4551ZM112.225 26H106.951V0.40625H112.225V26ZM117.129 26V0.40625H125.004C127.254 0.40625 129.264 0.916016 131.033 1.93555C132.814 2.94336 134.203 4.38477 135.199 6.25977C136.195 8.12305 136.693 10.2441 136.693 12.623V13.8008C136.693 16.1797 136.201 18.2949 135.217 20.1465C134.244 21.998 132.867 23.4336 131.086 24.4531C129.305 25.4727 127.295 25.9883 125.057 26H117.129ZM122.402 4.67773V21.7637H124.951C127.014 21.7637 128.59 21.0898 129.68 19.7422C130.77 18.3945 131.326 16.4668 131.35 13.959V12.6055C131.35 10.0039 130.811 8.03516 129.732 6.69922C128.654 5.35156 127.078 4.67773 125.004 4.67773H122.402ZM154.605 20.7266H145.359L143.602 26H137.994L147.521 0.40625H152.408L161.988 26H156.381L154.605 20.7266ZM146.783 16.4551H153.182L149.965 6.875L146.783 16.4551ZM180.234 0.40625L186.809 18.9688L193.348 0.40625H200.273V26H194.982V19.0039L195.51 6.92773L188.602 26H184.98L178.09 6.94531L178.617 19.0039V26H173.344V0.40625H180.234ZM204.809 23.5039C204.809 22.6953 205.078 22.0391 205.617 21.5352C206.168 21.0312 206.854 20.7793 207.674 20.7793C208.506 20.7793 209.191 21.0312 209.73 21.5352C210.281 22.0391 210.557 22.6953 210.557 23.5039C210.557 24.3008 210.287 24.9512 209.748 25.4551C209.209 25.9473 208.518 26.1934 207.674 26.1934C206.842 26.1934 206.156 25.9473 205.617 25.4551C205.078 24.9512 204.809 24.3008 204.809 23.5039ZM238.77 20.7266H229.523L227.766 26H222.158L231.686 0.40625H236.572L246.152 26H240.545L238.77 20.7266ZM230.947 16.4551H237.346L234.129 6.875L230.947 16.4551ZM248.473 23.5039C248.473 22.6953 248.742 22.0391 249.281 21.5352C249.832 21.0312 250.518 20.7793 251.338 20.7793C252.17 20.7793 252.855 21.0312 253.395 21.5352C253.945 22.0391 254.221 22.6953 254.221 23.5039C254.221 24.3008 253.951 24.9512 253.412 25.4551C252.873 25.9473 252.182 26.1934 251.338 26.1934C250.506 26.1934 249.82 25.9473 249.281 25.4551C248.742 24.9512 248.473 24.3008 248.473 23.5039Z" fill="black"/>
      </svg> */}
          <Logo src={LOGO} alt='logo' />
        </Link>
        <Hamburger onClick={OpenMenu}>
          <FontAwesomeIcon icon={faBars} />
        </Hamburger>
        <SideNav className={`${isOpenMenu ? "show" : "hide"}`}>
          <CloseMenuBTN onClick={CloseMenu}>
            <FontAwesomeIcon id="closebtn" icon={faXmark} />
          </CloseMenuBTN>
          <ul>
            {links.map((link, index) => (
              <li key={index}>
                <Link
                  to={link[1]}
                  className={location.pathname === link[1] ? "bold" : null}
                  onClick={CloseMenu}
                  >
                  {link[0]}
                </Link>
              </li>
            ))}
          </ul>
        </SideNav>
        <NavList>
          {links.map((link, index) => (
            <li key={index}>
              <Link
                to={link[1]}
                className={location.pathname === link[1] ? "bold" : null}>
                {link[0]}
              </Link>
            </li>
          ))}
        </NavList>
      </Content>
    </Wrapper>
  );
};
export default Nav;
